<template>
  <!-- 通貨：加密幣 + 法幣（來源 get-coinlist + get-fiatlist） -->
  <div class="crypto-select-frame">
    <div class="colu-12 for-label">
      {{ $t("Bao.currency") }}
    </div>
    <div class="lang-select">
      <button type="button" class="btn-select" @click="toggleDropdown">
        <li v-if="selectedCurrency">
          <img :src="iconFor(selectedCurrency)" :alt="selectedCurrency.symbol" @error="onImgError">
          <span>{{ selectedCurrency.symbol }}</span>
        </li>
      </button>
      <div class="b" :class="{ active: isOpen }">
        <ul class="crypto-list">
          <li
            v-for="currency in currencyList"
            :key="`${currency.type}-${currency.symbol}`"
            @click="selectCurrency(currency)"
          >
            <img :src="iconFor(currency)" :alt="currency.symbol" @error="onImgError">
            <span>{{ currency.symbol }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getCoinlist, getFiatlist } from '@/api/payment'
import { getWalletImagePath } from '@/utils/tool'
import { mapGetters } from 'vuex'

export default {
  name: 'DepositUseCcInvoice',
  props: {
    /** 目前選定的幣別 symbol（.sync），送出時直接當作 currency */
    symbol: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpen: false,
      // [{ symbol, type: 'crypto' | 'fiat' }]，加密幣在前、法幣在後
      currencyList: []
    }
  },
  computed: {
    ...mapGetters(['brandInfo', 'walletInfo']),
    selectedCurrency() {
      return this.currencyList.find(c => c.symbol === this.symbol) || null
    },
    // 主錢包（用於法幣圖示），找不到則以站台主幣別組一個
    mainWallet() {
      return (this.walletInfo || []).find(w =>
        w.wallet_type === 'main' && w.currency === this.brandInfo.currency
      ) || { wallet_type: 'main', currency: this.brandInfo.currency }
    }
  },
  created() {
    this.loadCurrencyList()
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    selectCurrency(currency) {
      this.isOpen = false
      this.$emit('update:symbol', currency.symbol)
    },
    // 加密幣用原本的本地 crypto-{symbol}.svg；法幣用主錢包的圖片
    iconFor(currency) {
      if (currency && currency.type === 'fiat') {
        return getWalletImagePath(this.mainWallet)
      }
      try {
        return this.$getThemeImagePath(`crypto-${currency.symbol.toLowerCase()}.svg`)
      } catch (e) {
        return this.$getThemeImagePath('default-crypto.svg')
      }
    },
    // 圖片載入失敗時退回 default-crypto.svg
    onImgError(event) {
      event.target.src = this.$getThemeImagePath('default-crypto.svg')
    },
    loadCurrencyList() {
      Promise.all([getCoinlist(), getFiatlist()])
        .then(([coinRes, fiatRes]) => {
          // 加密幣：比照加密幣頁，只留品牌 wallet_types 有開的
          const allCoins = coinRes.data.data || []
          const walletTypes = (this.brandInfo.wallet_types || [])
            .reduce((arr, item) => arr.concat(item.wallet_type), [])
          const coins = allCoins
            .filter(coin => walletTypes.includes(coin.symbol))
            .map(coin => ({ symbol: coin.symbol, type: 'crypto' }))

          // 法幣：只拿主錢包幣別（brandInfo.currency，站台主幣別）
          const mainCurrency = this.brandInfo.currency
          const fiats = (fiatRes.data.data || [])
            .filter(fiat => fiat.symbol === mainCurrency)
            .map(fiat => ({ symbol: fiat.symbol, type: 'fiat' }))

          this.currencyList = [...coins, ...fiats]

          // 預設選第一筆
          if (this.currencyList.length > 0) {
            this.$emit('update:symbol', this.currencyList[0].symbol)
          }
        })
        .catch((e) => {
          console.error(e)
        })
    }
  }
}
</script>
